const State = {
  START: 'START',
  DOCUMENTS_APPROVED: 'DOCUMENTS_APPROVED',
  OFFER_MADE: 'OFFER_MADE',
  OFFER_ACCEPTED: 'OFFER_ACCEPTED'
};

export default State;